<template>
  <div
    class="md-toolbar-row"
    v-if="isAuthenticated">
    <div class="md-toolbar-section-start">
      <router-link
        v-if='vueReturnLinkKwargs'
        :to="vueReturnLinkKwargs">
        <i class="material-icons">arrow_back</i>
      </router-link>
      <span class="md-title">{{ vueTitle }}</span>
    </div>
    <div class="md-toolbar-section-end">
      <md-menu
        md-size="huge"
        md-align-trigger
        @md-closed="notificationsMenuClosed">
        <md-badge
          class="notifications-badge"
          :md-content="unreadNotifications"
          md-dense>
          <md-button
            class="md-icon-button"
            md-menu-trigger>
            <md-icon>notifications</md-icon>
          </md-button>
        </md-badge>

        <md-menu-content>
          <md-menu-item
            v-for="notification in notifications"
            :key="`notification-${notification.id}`"
            :class="getNotificationClass(notification)">
            <router-link
              :to="{ name: notification.notification_type === 'success' ? 'Scenario results' : 'Scenario settings', params: {scenarioId: notification.scenario }}"
              class="notification-link">
              <div class="notification-label">{{ notification.label }}</div>
              <div class="notification-date">{{ notification.creation_date }}</div>
              <div class="notification-description">{{ notification.description }}</div>
            </router-link>
          </md-menu-item>
        </md-menu-content>
      </md-menu>

      <div>
        <md-avatar class="md-avatar-icon">{{ accountdetails.username|firstLetter }}</md-avatar>
        <md-menu
          md-align-trigger>
          <md-button md-menu-trigger>
            {{ accountdetails.username }}
            <md-icon>arrow_drop_down</md-icon>
          </md-button>
          <md-menu-content>
            <!-- <md-menu-item>Profile</md-menu-item> -->
            <md-menu-item><router-link to="/logout"><md-icon>power_settings_new</md-icon> Se déconnecter</router-link></md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import auth from '../api/auth'
import session from '../api/session'

export default {
  name: 'Header',
  data () {
    return {}
  },
  created () {
    var app = this
    if (app.$store.getters['auth/isAuthenticated']) {
      auth.getAccountDetails().catch(error => {
        if (error.response !== undefined && error.response.status === 401) {
          // The sessions has expired in the server, force the user to re-login
          app.$router.push({name: 'Logout'})
        }
      })
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'accountdetails']),
    ...mapGetters('routing', ['vueTitle']),
    ...mapGetters('routing', ['vueReturnLinkKwargs']),
    ...mapGetters('notifications', ['notifications', 'unreadNotifications'])
  },
  filters: {
    firstLetter: function (value) {
      if (!value) return ''
      return value.charAt(0)
    }
  },
  methods: {
    async notificationsMenuClosed () {
      for (const notification of this.notifications) {
        await session.post(`/api/notifications/${notification.id}/mark-as-read/`)
      }
    },
    getNotificationClass (notification) {
      let classes = 'notification-item'

      classes += ' ' + notification.notification_type

      if (!notification.is_read) {
        classes += ' unread-notification'
      }

      return classes
    }
  }
}
</script>

<style scoped lang="scss">
@import "../stylesheets/variables";
.md-toolbar-section-start{
  .md-title, a{
      color: white !important;
  }
}

.notifications-badge {
  margin-right: 15px;
}

.notification-item {
  border-bottom: 1px solid #ddd;
  .notification-link {
    display: grid;
    color: #444 !important;
    gap: 0.3rem;
    padding: 5px;
  }

  &:hover {
    background-color: rgba(#86ad19, 0.1);
    .notification-link {
      color: inherit;
    }
  }

  &:not(.unread-notification) {
    .notification-link {
      color: #888;
      opacity: 0.6;
    }
  }

  &.unread-notification {
    background-color: project-theme('background');
  }

  .notification-label {
    font-weight: bold;
  }

  .notification-date {
    font-size: 80%;
  }

  &.success {
    .notification-label {
      color: project-theme('primary');
    }
  }
  &.info {
    .notification-label {
      color: #22a6b3;
    }
  }
  &.error {
    .notification-label {
      color: project-theme('accent');
    }
  }
  &.warning {
    .notification-label {
      color: project-theme('slice3');
    }
  }
}

.md-menu-content.md-menu-content-huge {
  min-width: 350px !important;
  >>> .md-menu-content-container{
    .md-list {
      padding: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue